import axios from "axios";
import { BACKEND_URL } from "../utils/constant";

const getAllUsersData = async (token, search = "", filters = {}) => {
  const config = {
    headers: { authorization: `Bearer ${token}` },
  };

  let url = `${BACKEND_URL}api/cust_user?search=${search}`;

  // Append advanced filters to URL
  Object.keys(filters).forEach(key => {
    if (filters[key]) {
      url += `&${key}=${filters[key]}`;
    }
  });

  const response = await axios.get(url, config);
  return response;
};
const getAllUsers = async (token, limit, offset, search = "", filters = {}) => {
  const config = {
    headers: { authorization: `Bearer ${token}` },
  };

  let url = `${BACKEND_URL}api/cust_user?limit=${limit}&offset=${offset}&search=${search}`;

  // Append advanced filters to URL
  Object.keys(filters).forEach(key => {
    if (filters[key]) {
      url += `&${key}=${filters[key]}`;
    }
  });

  const response = await axios.get(url, config);
  return response;
};

const getOneUser = async (token, id) => {
  const config = {
    headers: { authorization: `Bearer ${token}` },
  };
  const response = await axios.get(`${BACKEND_URL}api/cust_user/${id}`, config);
  return response;
};

const searchUser = async (token, username) => {
  const config = {
    headers: { authorization: `Bearer ${token}` },
  };
  const res = await axios.get(
    `${BACKEND_URL}api/cust_user/${username}`,
    config
  );
  return res;
};

const deleteUser = async (token, id) => {
  const config = {
    headers: { authorization: `Bearer ${token}` },
  };
  const res = await axios.delete(`${BACKEND_URL}api/cust_user/${id}`, config);
  return res;
};

const updateUser = async (token, id, data) => {
  const config = {
    headers: { authorization: `Bearer ${token}` },
  };
  const res = await axios.put(`${BACKEND_URL}api/cust_user/${id}`, data, config);
  return res;
};

const createUser = async (token, data) => {
  const config = {
    headers: { authorization: `Bearer ${token}` },
  };
  const res = await axios.post(`${BACKEND_URL}api/cust_user`, data, config);
  return res;
};

export default {
  getAllUsers,
  getOneUser,
  searchUser,
  deleteUser,
  getAllUsersData,
  updateUser,
  createUser,
};
